import { render, staticRenderFns } from "./BasketBestDeals.vue?vue&type=template&id=57558dc9&scoped=true&"
import script from "./BasketBestDeals.vue?vue&type=script&lang=js&"
export * from "./BasketBestDeals.vue?vue&type=script&lang=js&"
import style0 from "./BasketBestDeals.vue?vue&type=style&index=0&id=57558dc9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57558dc9",
  null
  
)

export default component.exports